let environment = {
  api_url: `https://ma.amazonads.cn/api`,
  app_url: `https://ma.amazonads.cn/app`,
  upload_url: `https://up-1.amazonads.cn`,
  domain: `https://fe.amazonads.cn`,
  system_domain: `https://ma.amazonads.cn`,
  no_auth_url: `https://ma.amazonads.cn/Index/defaultContent`,
  set_souce: `https://ma.amazonads.cn/leads/website/source-setting/index`,
  login_url: `https://ma.amazonads.cn/user/index/login`
}
export default environment